module.exports = __webpack_public_path__ + "static/img/live-pro-interaction.b264708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/how-it-works/live-pro-interaction.png
// module id = KHkN
// module chunks = 38